import { IDownloadFile, IFetchData } from "../_types/post";
import { APIGet, APIPost, Download, Stream } from "./http";

export interface DownloadableReport {
    asJson: string;
    asCSV: string;
}

export interface CMSMetaData {
    locationName: string,
    todayString: string,
    yesterdayString: string,
    reportDate: string,
    expired: boolean,
    yesterdayWashCount: number,
    todayWashCount: number,
    id: number,
    uuid: string
};

export interface CMSMetaDataPost {
    id: number,
    uuid: string,
    yesterdayWashCount: number,
    todayWashCount: number
};

export const GetLinkBack = async (id: number, uuid: string): Promise<string> => {
    let toReturn: string | null = '';

    let request: IFetchData = {
        relay_to: `/cms/linkback/${id}/${uuid}`,
        method: "GET",
        authorize: false,
        service: "ewapi",
        refresh: false,
        contentType: "text/html"
    };

    toReturn = await APIGet(request);
    
    return toReturn || '';

}

export const GetMetaData = async (id: number, uuid: string): Promise<CMSMetaData | null> => {
    let toReturn: CMSMetaData | null = null;

    let request: IFetchData = {
        relay_to: `/cms/meta/${id}/${uuid}`,
        method: "GET",
        authorize: false,
        service: "ewapi",
        refresh: false
    };

    toReturn = await APIGet(request);
    // if (toReturn) {
    //     toReturn.id = id;
    //     toReturn.uuid = uuid;
    // }
    
    return toReturn || null;

}

export const SaveMetaData = async (toPost: CMSMetaDataPost): Promise<CMSMetaData | null> => {
    let toReturn: CMSMetaData | null = null;

    let request: IFetchData = {
        relay_to: `/cms/meta`,
        method: "POST",
        authorize: false,
        service: "ewapi",
        refresh: false,
        ...toPost
    };

    toReturn = await APIPost(request);
    // if (toReturn) {
    //     toReturn.id = toPost.id;
    //     toReturn.uuid = toPost.uuid;
    // }
    return toReturn || null;

}

export const GetDownloadReport = async (report: string, period: string, id: number, uuid: string, abort?: AbortController): Promise<DownloadableReport | null> => {
    let toReturn: DownloadableReport | null = null;

    let request: IFetchData = {
        relay_to: `/cms/download_report/${id}/${uuid}/${report}/${period}`,
        method: "GET",
        authorize: false,
        service: "ewapi",
        refresh: false
        //contentType: "text/plain"
    };

    toReturn = await APIPost(request, abort);
    
    return toReturn || null;

}